var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResendInvite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 187.6 187.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #1d76bc;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 93.6,
    cy: 94.4,
    r: 92.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M133.6,56.3c0-.4,0-.8,0-1.3,0-3.6,0-7.1,0-10.7,0-2.8,2.3-5,5-5,2.7,0,4.9,2.1,4.9,4.9,0,8.4,0,16.7,0,25.1,0,2.9-2.1,5-5,5-8.3,0-16.6,0-25,0-2.9,0-5.1-2.3-5-5.1,0-2.8,2.2-4.9,5.2-4.9,4,0,8,0,12,0,.4,0,.7,0,1.1,0l.2-.4c-2.4-2-4.6-4.3-7.2-6.1-25-17.8-59.5-6.5-69.1,22.6-1.5,4.5-2.1,9.1-2.2,13.8,0,3-2.4,5.1-5.3,5-2.7-.1-4.7-2.3-4.7-5.3,0-8.4,1.8-16.4,5.6-23.8,8-15.8,20.7-26,38.1-29.6,19-3.9,35.8,1.2,49.9,14.6.4.4.7.9,1,1.3.1,0,.3-.2.4-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M53.6,132.5c0,.4,0,.7,0,1.1,0,3.5,0,7,0,10.5,0,3-2.1,5.2-5,5.3-2.8,0-5-2.2-5-5.2,0-8.2,0-16.4,0-24.6,0-3.1,2.1-5.2,5.2-5.2,8.2,0,16.4,0,24.6,0,3,0,5.2,2.2,5.2,5,0,2.8-2.2,5-5.3,5-3.9,0-7.9,0-11.8,0-.4,0-.8,0-1.1,0,0,0-.1.2-.2.3,1.7,1.5,3.3,3.2,5,4.6,8.9,7.1,19,10.5,30.4,10.1,19.8-.7,37.5-15.3,41.7-34.7.7-3.2,1-6.5,1.2-9.7.2-3.3,2.1-5.5,5.1-5.5,3,0,5,2.3,5,5.7-.4,24.3-16.6,45.8-40,52.1-20.4,5.5-38.5.6-53.8-14-.3-.3-.4-.8-.6-1.1l-.5.4Z"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResendInvite);
export default __webpack_public_path__ + "static/media/resend-invite.ff17af74.svg";
export { ForwardRef as ReactComponent };